import { X } from "lucide-react";
import { Button } from "../../ui/Button";
import { useChat } from "../../context/ChatContext";

const ChatHeader = () => {
    const { toggleChat } = useChat();

    return (
        <div className="w-full pt-3 px-2 flex flex-row justify-between items-center">
            <div>
            </div>

            <div className="flex flex-row">
              
                <Button variant="ghost" size="icon" onClick={() => toggleChat(false)}>
                    <X />
                </Button>
            </div>
        </div>
    )
};

export default ChatHeader;